import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { Tweet, TweetObject } from "../Tweet";

import styles from "./Feed.module.scss";

interface TwitterFeedProps {
  className?: string;
  handle: string;
}

const TwitterFeed: React.FC<TwitterFeedProps> = ({ handle, className }) => {
  // const twitterRef = useRef(client());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<false | string>(false);
  const [items, setItems] = useState<TweetObject[]>([]);

  useEffect(() => {
    fetch(`/.netlify/functions/tweets?username=${handle}`)
      .then(resp => resp.json())
      .then(json => {
        if (json.error) {
          throw Error(json.error);
        }
        setItems(json);
      })
      .catch(e => setError("Could not fetch Twitter feed"))
      .finally(() => setLoading(false));
  }, [handle]);

  if (loading) {
    return <span className={styles.loading}>Loading...</span>;
  }

  return (
    <div className={classNames(styles.wrapper, className)}>
      {error && (
        <p className={styles.error}>
          {error}
          <br />
          <a
            href={`https://twitter.com/${handle}`}
            target="_blank"
            rel="noreferrer noopener"
          >
            https://twitter.com/{handle}
          </a>
        </p>
      )}
      {!error && items.map((item, indx) => <Tweet key={indx} {...item} />)}
    </div>
  );
};

export { TwitterFeed };
